export default {"src":"/_next/static/media/logout.849b06a0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};